import { useState, useRef, useEffect } from 'react';

interface Category {
  name: string;
  url: string;
  icon: string;
}

const categories: Category[] = [
  { name: 'Обувь', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Худи / Свитера', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-2-line' },
  { name: 'Футболки', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Куртки', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-honour-line' },
  { name: 'Штаны / Шорты', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Головные уборы', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-line' },
  { name: 'Комплекты', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Нижнее бельё', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-user-heart-line' },
  { name: 'Джерси', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { name: 'Аксессуары', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Сумки', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Ремни', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Парфюмерия', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-leaf-line' },
  { name: 'Разное', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

// ... existing code ...
export default function CategorySection() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            Категории товаров
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Выберите категорию и перейдите к покупкам через YOYBUY Spreadsheet на kaspreadsheet.com
          </p>
        </div>

        <div className="relative mb-6 md:mb-8 flex justify-center" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="whitespace-nowrap inline-flex items-center justify-between gap-2 w-full max-w-md px-5 py-3 rounded-lg bg-background-100 border border-background-300/60 text-foreground-800 text-sm md:text-base font-medium hover:bg-background-200 transition-colors cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-menu-search-line w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-foreground-500" />
              {isOpen ? 'Выберите категорию' : 'Все категории товаров'}
            </span>
            {isOpen ? (
              <i className="ri-arrow-up-s-line w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-foreground-400" />
            ) : (
              <i className="ri-arrow-down-s-line w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-foreground-400" />
            )}
          </button>

          {isOpen && (
            <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 w-full max-w-md bg-background-50 border border-background-200/70 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setIsOpen(false)}
                  className="whitespace-nowrap flex items-center gap-3 px-5 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-primary-500`} />
                  {cat.name}
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center text-foreground-300 ml-auto" />
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 md:gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap group flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg bg-background-100/70 border border-background-200/50 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 group-hover:border-primary-200 group-hover:bg-primary-100/50 transition-colors">
                <i className={`${cat.icon} w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-foreground-600 group-hover:text-primary-600 transition-colors`} />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700 text-center leading-tight transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}